import { makeStyles } from "@material-ui/core/styles";
import {
  primary,
  grey300,
  black,
} from "../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  stepButton: {
    margin: theme.spacing(0.5),
    borderRadius: 0,
    borderColor: grey300,
    color: grey300,
    borderWidth: "0 0 3px 0",
    textTransform: "none",
    minWidth: 200,
    fontWeight: "light",

    "&:hover": {
      backgroundColor: "transparent",
    },

    "&:disabled": {
      borderRadius: 0,
      borderColor: grey300,
      color: grey300,
      borderWidth: "0 0 3px 0",
    },
  },
  activeButton: {
    borderColor: primary,
    color: black,
  },
  currentStepButton: {
    fontWeight: "bold",
  },
  disabledButton: {
    cursor: "context-menu",
  },
}));

export default useStyles;
